var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysMarkMultiples = function SvgSysMarkMultiples(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.3 11.807-3.149-3.1a.503.503 0 0 1 .135-.85.5.5 0 0 1 .565.141l2.8 2.754.167-.172a.506.506 0 0 1 .709 0 .498.498 0 0 1 0 .705l-.52.518a.49.49 0 0 1-.351.146.474.474 0 0 1-.356-.142Zm3.237-.332-3.149-3.1a.502.502 0 0 1 .71-.715l2.8 2.754 6.258-6.22a.5.5 0 0 1 .848.353.507.507 0 0 1-.148.355l-6.61 6.573a.506.506 0 0 1-.701 0h-.008Zm-.274-2.621a.499.499 0 0 1 0-.71l3.98-3.95a.499.499 0 0 1 .7.708L7.967 8.854a.499.499 0 0 1-.71 0h.006Z"
  })));
};
export default SvgSysMarkMultiples;